
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Ref, Prop, Watch } from "vue-property-decorator";
    import { VForm } from "@/vForm";
    import { MapOptions } from "@/model/pagePartOptions/MapOptions";

    @Component({ })
    export default class MapPartEdit extends Vue {

        @Ref("editForm")
        readonly editForm!: VForm;

        @Prop({ required: true })
        pagePartOptions!: MapOptions;

        validateLatitude(): string|boolean {
            const latitude = Number(this.pagePartOptions.latitude);
            if(isNaN(latitude)) return "Not a valid value";
            if (latitude === 0 && +this.pagePartOptions.longitude === 0) {
                return "The latitude and longitude cannot both be zero.";
            }
            if(latitude > 180) return "Cannot be greater than 180 degrees";
            if(latitude < -180) return "Cannot be less than than -180 degrees";
            return true;
        }

        validateLongitude(): string|boolean {
            const longitude = Number(this.pagePartOptions.longitude);
            if(isNaN(longitude)) return "Not a valid value";
            if (longitude === 0 && +this.pagePartOptions.latitude === 0) {
                return "The latitude and longitude cannot both be zero.";
            }
            if(longitude > 180) return "Cannot be greater than 180 degrees";
            if(longitude < -180) return "Cannot be less than than -180 degrees";
            return true;
        }

        // called by parent
        validate(): boolean {
            return this.editForm.validate();
        }
    }
